import {SHOW_REPORT_STATUSES} from '@app/utils/constants';
import {PieChart, MainLoader} from '@components';
import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {sagaActions} from './redux/saga';

const ValidatorOverview = () => {
  const dispatch = useDispatch();
  const reportsAnalyticsData = useSelector(
    (state) => state.validators.reportsAnalyticsData
  );
  useEffect(() => {
    dispatch({
      type: sagaActions.FETCH_VALIDATOR_REPORTS_ANALYTICS,
      payload: {},
    });
  }, []);

  const getLegendColor = (item) => {
    if (item.status === 'Rejected') {
      return '#c9313f';
    }
    if (item.status === 'Approved') {
      return '#479541';
    }
    return '#bbb';
  };

  const reportData = useMemo(() => {
    return reportsAnalyticsData.data.map((item) => {
      return {
        name: SHOW_REPORT_STATUSES[item.status] || item.status,
        value: item.totalReports,
        color: getLegendColor(item),
      };
    });
  }, [reportsAnalyticsData.data]);

  return (
    <>
      {reportsAnalyticsData.loading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      )}
      {!reportsAnalyticsData.loading && reportsAnalyticsData.data.length ? (
        <div className="card p-2" style={{width: '450px'}}>
          <h6>Overview</h6>
          <PieChart
            data={reportData}
            width={400}
            height={400}
            outerRadius={150}
          />
        </div>
      ) : null}
    </>
  );
};

export default ValidatorOverview;
